import { InjectionToken } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { PlatformType } from '../enums';

export interface PlatformProvider {
  get isAndroid(): boolean;
  get isiOS(): boolean;
  get isNativeRun(): boolean;
  get platformType(): PlatformType;
}

export const PLATFORM_TOKEN: InjectionToken<PlatformProvider> = new InjectionToken<PlatformProvider>('PLATFORM_TOKEN', {
  factory: (): PlatformProvider => {
    const isNative: boolean = Capacitor.isNativePlatform();
    const platform: string = Capacitor.getPlatform();

    return {
      get isAndroid(): boolean {
        return isNative && platform === PlatformType.ANDROID;
      },

      get isiOS(): boolean {
        return isNative && platform === PlatformType.IOS;
      },

      get isNativeRun(): boolean {
        return isNative;
      },

      get platformType(): PlatformType {
        if (this.isAndroid) return PlatformType.ANDROID;
        if (this.isiOS) return PlatformType.IOS;
        return PlatformType.WEB;
      }
    };
  }
});
